import { Injectable, NgZone } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

/**
 * The MSAL interceptor acquireTokenSilent runs outside the Angular zone.
 * As a result, HTTP responses (and component subscribe callbacks) also run
 * outside the zone, preventing change detection from firing.
 *
 * This interceptor re-enters the Angular zone for every HTTP emission so that
 * change detection runs after data arrives.
 *
 * Must be registered FIRST in HTTP_INTERCEPTORS (before MsalInterceptor).
 */
@Injectable()
export class NgZoneInterceptor implements HttpInterceptor {
  constructor(private ngZone: NgZone) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return new Observable<HttpEvent<unknown>>(observer => {
      const subscription = next.handle(request).subscribe({
        next: value => this.ngZone.run(() => observer.next(value)),
        error: err => this.ngZone.run(() => observer.error(err)),
        complete: () => this.ngZone.run(() => observer.complete())
      });
      return () => subscription.unsubscribe();
    });
  }
}
